import { Description, type DescriptionSet } from "../AppState";
import { format_name } from "../util";
import "../css/details.css"

export default function DescriptionPanel({descriptions}: {descriptions: DescriptionSet}){
    
    return (
    <div id="descriptionPanel">
        <h2> Playbooks </h2>
        <div id="playbookList">
        {
            Object.entries(descriptions).map(
                ([playbook, description] ) => {
                    return <PlaybookDescription name={format_name(playbook)} description={description}></PlaybookDescription>
                }
            )
        }
        </div>
    </div>)
}

const lst = (arr: any[]) => {
    return (
        <ul>
            {arr.map((elt)=>{return <li>{elt}</li>})}
        </ul>
    )
}

function PlaybookDescription({name, description}: {name: string, description: Description}){
    if ("moves" in description) {
        return (
            <details name="playbooks"> 
                <summary> <h4> {name}</h4> </summary>
                {lst(description.moves)}
            </details>
        )
    } else {
        return (
            <details name="playbooks"> 
                <summary> <h4> {name}  </h4> </summary>
                <h5> Strong Moves </h5>
                {lst(description.strong)}
                <h5> Lateral Moves </h5>
                {lst(description.lateral)}
                <h5> Vulnerable Moves </h5>
                {lst(description.vulnerable)}
            </details>
        )
    }
}